var React = require('react');

function ShapeMobileNav (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M275,-0.000530862936 L274.997,634 L1.15085943,634.001413 C4.42427836,568.15037 5.70732522,495.885576 5,417.207031 C4.25367063,334.189903 0.00358918638,240.981395 0.819460288,164.392578 C1.7725617,74.9214473 12.0806633,8.55651529 1.48582634,-0.000208685049 L275,-0.000530862936 Z"}));
}

ShapeMobileNav.defaultProps = {"viewBox":"0 0 275 634","version":"1.1","preserveAspectRatio":"none"};

module.exports = ShapeMobileNav;

ShapeMobileNav.default = ShapeMobileNav;
